import React from "react";
import { FiltersTypes } from "@common/types/filters/general";

interface Props {
    filters: FiltersTypes;
}

export const CloseDateFilterLabel: React.FC<Props> = ({ filters }) => {
    const { closeDateStart, closeDateEnd } = filters;

    if (!closeDateStart && !closeDateEnd) {
        return null;
    }

    if (closeDateStart && closeDateEnd) {
        return (
            <span>
                {closeDateStart.toLocaleDateString()} -{" "}
                {closeDateEnd.toLocaleDateString()}
            </span>
        );
    }

    if (closeDateStart) {
        return <span>From {closeDateStart.toLocaleDateString()}</span>;
    }

    if (closeDateEnd) {
        return <span>Until {closeDateEnd.toLocaleDateString()}</span>;
    }

    return null;
};
